import { trackEvent } from '../services/analyticsService';

// Vue directive for tracking clicks
// Usage: <button v-track-click="'button_name'">Click me</button>
// Or with properties: <button v-track-click="{ event: 'button_name', props: { color: 'red' } }">Click me</button>

export const trackClick = {
  mounted(el, binding) {
    const clickHandler = () => {
      if (typeof binding.value === 'string') {
        // Simple string usage: v-track-click="'button_name'"
        trackEvent(`button_clicked_${binding.value}`, {
          element_type: el.tagName.toLowerCase(),
          element_text: el.innerText?.substring(0, 50) || '',
          timestamp: new Date().toISOString()
        });
      } else if (typeof binding.value === 'object') {
        // Object usage: v-track-click="{ event: 'name', props: { ... } }"
        const { event, props = {} } = binding.value;
        trackEvent(`button_clicked_${event}`, {
          element_type: el.tagName.toLowerCase(),
          element_text: el.innerText?.substring(0, 50) || '',
          ...props,
          timestamp: new Date().toISOString()
        });
      }
    };

    el._clickHandler = clickHandler;
    el.addEventListener('click', clickHandler);
  },

  unmounted(el) {
    if (el._clickHandler) {
      el.removeEventListener('click', el._clickHandler);
      delete el._clickHandler;
    }
  }
};

export default trackClick;
